<section [class.text-color]="textColor">{{ label }}</section>